import React from 'react';

const DiscoverIcon = ({ className }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 32 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="20" rx="2" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.9245 10.0001C16.9245 11.8511 15.4245 13.3511 13.5735 13.3511C11.7225 13.3511 10.2225 11.8511 10.2225 10.0001C10.2225 8.14913 11.7225 6.64913 13.5735 6.64913C15.4245 6.64913 16.9245 8.14913 16.9245 10.0001Z"
        fill="#F27712"
      />
      <path
        d="M18.5735 6.89913H19.7735V13.1011H18.5735V6.89913ZM21.0735 6.89913H22.5735L24.3735 11.2991H24.4735V6.89913H25.6735V13.1011H24.2735L22.3735 8.50113H22.2735V13.1011H21.0735V6.89913Z"
        fill="#0B0B0B"
      />
      <path
        d="M7.57353 6.89913L5.47353 13.1011H6.77353L7.17353 12.0011H9.77353L10.1735 13.1011H11.4735L9.37353 6.89913H7.57353ZM7.57353 10.9011L8.47353 8.50113L9.37353 10.9011H7.57353Z"
        fill="#0B0B0B"
      />
    </svg>
  );
};

export default DiscoverIcon; 